// extracted by mini-css-extract-plugin
export default {"title":"UploadCartoonTitle_title__A3BBf"};